import { FC } from 'react';
import styles from './style.module.css';

import { Markdown } from '~/components/elements/Markdown/Markdown';

type Props = {
  guidance: string;
};

export const MedicalInstitutionGuidanceSection: FC<Props> = ({ guidance }) => {
  return (
    <div className={styles.root}>
      <div className={styles.title}>
        <h3>問診される方へ</h3>
        <div>問診前に必ずご一読ください</div>
      </div>
      <div className={styles.body}>
        <Markdown>{guidance}</Markdown>
      </div>
    </div>
  );
};
